<div class="kl-grid-form-root" [class.kl-grid-form-root--fullscreen]="isFullscreen()">
  @if (showToolbarArea() || (effectiveToolbar().search && searchPanelOpen())) {
    <kl-grid-form-toolbar
      [showToolbarArea]="showToolbarArea()"
      [isReadOnly]="isReadOnly()"
      [showAddRow]="showAddRow()"
      [searchEnabled]="effectiveToolbar().search"
      [importEnabled]="effectiveToolbar().import"
      [exportEnabled]="effectiveToolbar().export"
      [fullscreenEnabled]="effectiveToolbar().fullscreen"
      [bulkDeleteEnabled]="showBulkDeleteAction()"
      [isFullscreen]="isFullscreen()"
      [rowsLength]="rows().length"
      [processButtons]="processButtons()"
      [processMenuItems]="processMenuItems()"
      [customToolbarVisible]="customToolbarVisible()"
      [customToolbar]="customToolbar()"
      [searchPanelOpen]="searchPanelOpen()"
      [searchQuery]="searchQuery()"
      [toolbarTemplate]="toolbarTemplate()"
      (addRowClick)="onToolbarAddRowClick()"
      (searchClick)="toggleSearchPanel()"
      (exportClick)="exportXlsx()"
      (fullscreenClick)="toggleFullscreen()"
      (bulkDeleteClick)="onBulkDeleteClick()"
      (importFileSelected)="importFile.emit($event)"
      (searchQueryChange)="searchQuery.set($event)"
      (customToolbarActionClick)="onCustomToolbarAction($event)" />
  }
  @if (columnPreferencesEnabled()) {
    <kl-grid-column-settings-drawer
      #columnSettingsDrawer
      [visible]="sidebarVisible()"
      (visibleChange)="sidebarVisible.set($event)"
      [columnDefinitions]="effectiveColumnsForDrawer()"
      [designParentModule]="parentModuleName()"
      [designModule]="moduleName()"
      [designKey]="gridName()"
      [showGridDesignTab]="true"
      [invertDesignVisibility]="true"
      (resetToDefault)="onColumnDrawerResetToDefault()"
      (columnsChanged)="onColumnsChanged($event)" />
  }

  <div class="kl-grid-form-table-wrap">
    @if (showInitialLoader()) {
      <div class="kl-grid-form-body__loading">
        <div class="kl-grid-form-loading-panel">
          <ng-container *ngTemplateOutlet="loadingIndicatorTemplate" />
        </div>
      </div>
    }

    <div class="kl-grid-form-table-host" [class.kl-grid-form-table-host--blocked]="showLoadingOverlay()">
      @if (showLoadingOverlay()) {
        <div class="kl-grid-form-body__overlay">
          <ng-container *ngTemplateOutlet="loadingIndicatorTemplate" />
        </div>
      }
      <p-table
    [value]="orderedViewRows()"
    [columns]="dataColumnMeta()"
    [reorderableColumns]="columnReorderActive()"
    [scrollable]="true"
    [scrollHeight]="scrollHeight()"
    [virtualScroll]="effectiveVirtualScroll()"
    [virtualScrollItemSize]="virtualScrollItemSize()"
    [virtualScrollOptions]="virtualScrollOptions"
    [tableStyle]="tableMinWidthStyle()"
    editMode="cell"
    (onColReorder)="onColReorder($event)"
    (onRowReorder)="onRowReorder()"
    [paginator]="showPaginator()"
    paginatorPosition="bottom"
    [lazy]="showPaginator()"
    [lazyLoadOnInit]="false"
    [rows]="paginatorPageSize()"
    [first]="pageFirst()"
    [totalRecords]="totalRecords()"
    [showPageLinks]="false"
    [showCurrentPageReport]="showPaginator()"
    [currentPageReportTemplate]="pageReportTemplate()"
    [showFirstLastIcon]="true"
    paginatorStyleClass="kl-grid-paginator"
    (onPage)="onTablePage($event)"
    class="p-datatable-sm p-datatable-gridlines kl-grid-form-table"
    [class.kl-grid-form-table--fixed]="effectiveVirtualScroll()">
    <ng-template pTemplate="firstpagelinkicon"><i class="ph ph-caret-double-left" aria-hidden="true"></i></ng-template>
    <ng-template pTemplate="previouspagelinkicon"><i class="ph ph-caret-left" aria-hidden="true"></i></ng-template>
    <ng-template pTemplate="nextpagelinkicon"><i class="ph ph-caret-right" aria-hidden="true"></i></ng-template>
    <ng-template pTemplate="lastpagelinkicon"><i class="ph ph-caret-double-right" aria-hidden="true"></i></ng-template>
    <ng-template pTemplate="paginatorleft">
      @if (showPaginator()) {
        <span class="kl-grid-paginator-range">
          {{ 'grid_paginator_report' | translate: gridPaginatorReportParams() }}
        </span>
      }
    </ng-template>
    <ng-template #header>
      <tr>
        @if (columnPreferencesEnabled()) {
          <th
            pFrozenColumn
            class="kl-grid-form-settings-col kl-grid-rowheader-col kl-grid-rowheader-col--header"
            scope="col"
            (click)="openColumnSettings()">
            <i class="ph ph-gear grid-settings-icon"></i>
          </th>
        }
        @if (rowReorderActive()) {
          <th class="kl-grid-form-reorder-col"></th>
        }
        @for (col of displayedDataColumns(); track columnTrackKey(col, $index)) {
          @if (columnReorderActive() && !isRowSelectionColumn(col)) {
            <th pReorderableColumn [style.width]="col.width === '*' ? 'auto' : col.width ? col.width + 'px' : 'auto'">
              <div class="kl-grid-form-header-cell-wrap">
                <span
                  class="kl-grid-form-col-drag-handle ph ph-dots-six-vertical"
                  [attr.aria-label]="'column_drag_to_reorder' | translate"
                  [pTooltip]="'column_drag_to_reorder' | translate"
                  tooltipPosition="bottom"></span>
                <div class="kl-grid-form-header-cell" (mousedown)="$event.stopPropagation()">
                  <span class="kl-grid-form-header-title">{{ col.header | translate }}</span>
                  @if (showColumnSortUi(col) || showColumnFilterUi(col)) {
                    <kl-column-filter
                      [column]="toGridColumn(col)"
                      [data]="rows()"
                      [filterState]="getColumnFilterStateForCol(col)"
                      [showSort]="showColumnSortUi(col)"
                      [showValueFilter]="showColumnFilterUi(col)"
                      (sortAsc)="onColumnSortAsc($event)"
                      (sortDesc)="onColumnSortDesc($event)"
                      (filterApply)="onColumnFilterApply($event)"
                      (filterClear)="onColumnFilterClear($event)" />
                  }
                </div>
              </div>
            </th>
          } @else {
            <th [style.width]="col.width === '*' ? 'auto' : col.width ? col.width + 'px' : 'auto'">
              <div
                class="kl-grid-form-header-cell"
                [class.kl-grid-form-header-cell--selection]="isRowSelectionColumn(col)"
                (mousedown)="$event.stopPropagation()">
                @if (isRowSelectionColumn(col)) {
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="allRowsSelected()"
                    (ngModelChange)="toggleSelectAll($event)"
                    inputId="kl-gf-select-all"
                    (click)="$event.stopPropagation()" />
                }
                @if (!isRowSelectionColumn(col)) {
                  <span class="kl-grid-form-header-title">{{ col.header | translate }}</span>
                }
                @if (showColumnSortUi(col) || showColumnFilterUi(col)) {
                  <kl-column-filter
                    [column]="toGridColumn(col)"
                    [data]="rows()"
                    [filterState]="getColumnFilterStateForCol(col)"
                    [showSort]="showColumnSortUi(col)"
                    [showValueFilter]="showColumnFilterUi(col)"
                    (sortAsc)="onColumnSortAsc($event)"
                    (sortDesc)="onColumnSortDesc($event)"
                    (filterApply)="onColumnFilterApply($event)"
                    (filterClear)="onColumnFilterClear($event)" />
                }
              </div>
            </th>
          }
        }
      </tr>
    </ng-template>

    <ng-template #body let-row let-ri="rowIndex">
      <tr
        [class.kl-grid-row--alt]="stripedRows() && ri % 2 === 1"
        [class.kl-grid-form-row--selected]="isSourceRowSelected(ri)"
        [class.kl-grid-form-row--highlighted]="rowHighlight()?.(row)"
        [class.kl-grid-form-row--highlighted-secondary]="rowHighlightSecondary()?.(row)"
        [ngClass]="rowClass()?.(row)"
        [pReorderableRow]="ri"
        [pReorderableRowDisabled]="!rowReorderActive()"
        (click)="onBodyRowClick($event, ri)"
        (dblclick)="onBodyRowDblClick($event, ri)"
        (contextmenu)="onBodyRowContextMenu($event, ri)">
        @if (columnPreferencesEnabled()) {
          <td pFrozenColumn class="kl-grid-form-settings-col kl-grid-rowheader-col"></td>
        }
        @if (rowReorderActive()) {
          <td class="kl-grid-form-reorder-col text-center">
            <span
              class="kl-grid-form-row-handle ph ph-dots-six-vertical"
              pReorderableRowHandle
              [attr.aria-label]="'column_drag_to_reorder' | translate"
              [pTooltip]="'column_drag_to_reorder' | translate"
              tooltipPosition="bottom"></span>
          </td>
        }
        @for (col of displayedDataColumns(); track columnTrackKey(col, $index)) {
          <!-- Function inputs are arrow properties, so their references stay stable across change detection. -->
          <kl-grid-form-body-cell
            [row]="row"
            [col]="col"
            [ri]="ri"
            [isReadOnly]="isReadOnly()"
            [selectAllCheckbox]="selectAllCheckbox()"
            [cellButtonPending]="cellButtonPending()"
            [primeCellEditFocusSelector]="primeCellEditFocusSelector"
            [resolveSourceRowIndex]="resolveSourceRowIndex"
            [getNested]="getNested"
            [formatDisplayValue]="formatDisplayValue"
            [resolveDateCellValue]="resolveDateCellValue"
            [datePickerFormat]="datePickerFormat"
            [pickerDisplayLabel]="pickerDisplayLabel"
            [pickerHasDisplayValue]="pickerHasDisplayValue"
            (cellButtonClick)="onCellButtonClick($event.row, $event.col, $event.ri, $event.event)"
            (checkboxChange)="onCheckboxChange($event.row, $event.col, $event.value, $event.rowIndex)"
            (selectChange)="onSelectChange($event.row, $event.col, $event.value, $event.rowIndex)"
            (numberChange)="onNumberChange($event.row, $event.col, $event.value)"
            (dateChange)="onDateChange($event.row, $event.col, $event.value, $event.rowIndex)"
            (textChange)="onTextChange($event.row, $event.col, $event.value)"
            (cellCommit)="onCellCommit($event.row, $event.col, $event.rowIndex)"
            (clearPickerClick)="clearPickerValue($event.filteredRowIndex, $event.col)"
            (pickerButtonClick)="onPickerButtonClick($event.filteredRowIndex, $event.col)"
            (pickerTextInput)="
              pickerTextInput.emit({
                row: $event.row,
                column: $event.col,
                value: $event.value,
                rowIndex: $event.rowIndex,
              })
            " />
        }
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td [colSpan]="tableLeadColSpan()" class="text-center text-muted">{{ 'no_data' | translate }}</td>
      </tr>
    </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template #loadingIndicatorTemplate>
    <kl-loader [label]="loadingText() || 'loading'">
      @if (loadingProgress(); as progress) {
        <div class="kl-grid-form-loading-progress">
          <span class="kl-grid-form-loading-progress__label">{{ 'loading_progress' | translate: progress }}</span>
          <div
            class="kl-grid-form-loading-progress__bar"
            role="progressbar"
            [attr.aria-label]="loadingText() || 'loading' | translate"
            aria-valuemin="0"
            [attr.aria-valuemax]="progress.total"
            [attr.aria-valuenow]="progress.loaded">
            <div
              class="kl-grid-form-loading-progress__fill"
              [style.width.%]="(progress.loaded / progress.total) * 100"></div>
          </div>
        </div>
      }
    </kl-loader>
  </ng-template>

  <p-contextMenu #rowContextMenu [model]="rowContextMenuModel" appendTo="body" />
</div>
